var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_99_30890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.17139 8.58299H12.9409V10.1553C13.0091 10.0766 13.0437 10.0439 13.0696 10.0053C13.9959 8.6439 15.3168 8.17708 16.9018 8.32936C18.9737 8.5289 20.2977 9.92663 20.6323 12.1366C20.6973 12.568 20.7255 13.0084 20.7278 13.4448C20.7373 15.5448 20.7323 17.6444 20.7323 19.7444C20.7323 19.8107 20.7323 19.8771 20.7323 19.9594H16.9427V19.678C16.9427 17.7971 16.9509 15.9162 16.9368 14.0357C16.9337 13.6012 16.8955 13.158 16.8018 12.7344C16.6514 12.0516 16.2709 11.5266 15.5487 11.3584C14.7705 11.1775 14.0764 11.3525 13.5259 11.9553C13.1918 12.3212 12.9755 12.748 12.965 13.2571C12.9568 13.6571 12.9468 14.0575 12.9464 14.4575C12.9446 16.1948 12.9455 17.9321 12.9455 19.6694C12.9455 19.7589 12.9455 19.848 12.9455 19.9562H9.17139V8.58299Z",
    fill: "url(#paint0_linear_99_30890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.28662 8.58398H7.04208V19.9585H3.28662V8.58398Z",
    fill: "url(#paint1_linear_99_30890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.19144 7.00848C4.09326 7.01166 3.28008 6.40757 3.08644 5.4703C2.83871 4.27394 3.6178 3.20167 4.83689 3.09939C5.17689 3.07076 5.5378 3.0853 5.86735 3.16757C6.8028 3.40121 7.37962 4.25121 7.30098 5.20712C7.2228 6.15757 6.49417 6.8853 5.5178 6.98666C5.3978 6.99894 5.27689 7.00257 5.19144 7.00848Z",
    fill: "url(#paint2_linear_99_30890)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_99_30890",
    x1: 9.16499,
    y1: 14.1306,
    x2: 28.9995,
    y2: 0.475586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_99_30890",
    x1: 3.28454,
    y1: 14.2713,
    x2: 14.9995,
    y2: 6.97461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_99_30890",
    x1: 2.49951,
    y1: 6.47461,
    x2: 8.99951,
    y2: 1.97461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_99_30890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.8182,
    height: 17,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linked_in.3791ba1f525faa8e272c4059cc516d35.svg";
export { ForwardRef as ReactComponent };